var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.000152588,
    width: 32,
    height: 32,
    rx: 12,
    fill: "#272729",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9038 9.18811L22.812 10.0964C23.0629 10.3472 23.0629 10.7538 22.812 11.0046L17.8167 16L22.812 20.9954C23.0629 21.2462 23.0629 21.6528 22.812 21.9036L21.9038 22.8119C21.653 23.0627 21.2463 23.0627 20.9955 22.8119L16.0002 17.8165L11.0048 22.8119C10.754 23.0627 10.3473 23.0627 10.0965 22.8119L9.18826 21.9036C8.93745 21.6528 8.93745 21.2462 9.18826 20.9954L14.1836 16L9.18826 11.0046C8.93745 10.7538 8.93745 10.3472 9.18826 10.0964L10.0965 9.18811C10.3473 8.9373 10.754 8.9373 11.0048 9.18811L16.0002 14.1835L20.9955 9.18811C21.2463 8.9373 21.653 8.9373 21.9038 9.18811Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.17c82a09e3534bf53f47011a17dc885e.svg";
export { ForwardRef as ReactComponent };